
const SelectYear = ({ onChange, year }) => {
    if (!year) { return null; }

    return (
        <input
            className="input"
            type="number"
            name="year"
            min="2022"
            max="3000"
            value={year}
            onChange={onChange}
            placeholder="Count"
        />
    )
}

export default SelectYear;
